// extracted by mini-css-extract-plugin
export default {"headline":"ItemsTop_headline_X7yLc","name":"ItemsTop_name_UkWnT","amount":"ItemsTop_amount_XM8Xe","value":"ItemsTop_value_nq3Vb"};